import { render } from "./PayPeriodReview.vue?vue&type=template&id=0575065e&scoped=true"
import script from "./PayPeriodReview.vue?vue&type=script&lang=js"
export * from "./PayPeriodReview.vue?vue&type=script&lang=js"

import "./PayPeriodReview.vue?vue&type=style&index=0&id=0575065e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0575065e"]])

export default __exports__